<!-- =========================================================================================
  File Name: UserView.vue
  Description: User View page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
	<div id="page-order-view" class="data-list-container">
		<div>
			<div class="item-filters">
				<div slot="header" class="w-full mb-12 flex" style="align-items: center;">
					<div class="flex flex-grow justify-start flex-wrap" :key="upStatus">
						<div class="md:flex lg:flex xl:flex vs-con-loading__container" :key="idxStatus" v-for="(statusLabel, idxStatus) in productList">
							<div class="md:flex lg:flex xl:flex mr-3 mb-3">
								<vs-button title="Tìm theo khớp giá" class="w-36 font-bold" :color="statusLabel.color" :type="statusLabel.active ? 'filled' : 'border'" @click="filterByStatus(idxStatus)">{{statusLabel.name}}</vs-button>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="flex flex-wrap justify-center">
				<div class="relative mx-4 my-4 cursor-pointer item-box" :key="idx" v-for="(sell, idx) in $store.state.moduleProduct.sells">
					<div class="vs-con-loading__container sell-box" @click="gotoDetailSell(sell.id)">
						<div class="sell-img-box pl-2">
							<img :src="sell.photos && sell.photos.length ? sell.photos[0].path : 'https://sanphupham.vn/storage/app/media/assets/images/noimg.jpg'" />
						</div>
						<div class="flex justify-between items-center pl-3 pt-2 pr-3">
							<label class="sell-p-name">{{sell.product ? sell.product.name : '-'}}</label>
							<label class="sell-p-qty">{{ $helper.numFormat(sell.quantity) }} KG</label>
						</div>
						<div class="pl-3">
							<label class="sell-p-price">{{ $helper.numFormat(sell.price) }} VND</label>
						</div>
						<div class="flex justify-between items-center px-3 pt-2 pb-5">
							<div class="grid">
								<label class="sell-p-ttl">Tổng cộng</label>
								<label class="sell-p-ttv">{{ $helper.numFormat(sell.quantity * sell.price) }} VND</label>
								<label class="sell-p-ttt">Đã bao gồm VAT</label>
							</div>
							<vs-button title="Đặt lệnh ngay" class="w-22 font-bold py-0 px-3 rounded-none" :color="'primary'" :type="'filled'" @click.stop="buyNow(sell)">MUA NGAY</vs-button>
						</div>
					</div>
					<div class="flex items-center justify-start sell-trend">
						<svg v-if="getRangePercent(sell) > 0" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path d="M4.08337 9.91663L9.91671 4.08329" stroke="#36E732" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
							<path d="M4.08337 4.08329H9.91671V9.91663" stroke="#36E732" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
						</svg>
						<svg v-if="getRangePercent(sell) < 0" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path d="M4.08337 4.08337L9.91671 9.91671" stroke="#E73232" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
							<path d="M9.91671 4.08337V9.91671H4.08337" stroke="#E73232" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
						</svg>

						<label :style="{color: getRangePercent(sell) > 0 ? '#36E732' : (getRangePercent(sell) < 0 ? '#E73232' : 'rgb(204, 170, 0)')}">({{(getRangePercent(sell) * 100).toFixed(2)}}) %</label>
					</div>
					<div class="sell-trend-2"></div>
				</div>
			</div>
		</div>
		<div class="w-full center mt-4">
			<CbsPagination :total="total" v-model="page"></CbsPagination>
		</div>
		<OrderForm :isPopupActive="customerDialog" @closePopup="toggleCustomerDialog" :data="customerData" />
	</div>
</template>

<script>
import CbsPagination from "@/components/cbs-pagination/CbsPagination";
import UserDetail from "./UserDetail.vue";
import OrderForm from "./OrderForm.vue";
import OrderDetail from "./OrderDetail.vue";
import KcsForm from "./KcsForm.vue";
import ChooseSells from "./ChooseSells.vue";
import SellerRatingForm from "./SellerRatingForm.vue";

export default {
	components: {
		CbsPagination,
		UserDetail,
		OrderForm,
		OrderDetail,
		KcsForm,
		ChooseSells,
		SellerRatingForm
	},
	data() {
		return {
			customLimit: 20,
			productList: [],
			sellerRatingDialog: false,
			sellerRatingData: {},
			shippingDialog: false,
			shippingData: {},
			listUser: [],
			page: 1,
			searchText: "",
			userDialog: false,
			userData: {},
			detailUserDialogData: null,
			isDetailUserDialogActive: false,
			isDetailUserCustomerDialogActive: false,
			customerDialog: false,
			filters: {
				// status: 2
			},
			canSelectSupplier: false,
			canBuy: false,
			canSell: false,
			customerData: {},
			userToken: '',
			sellsDialog: false,
			sellsData: {},
			upStatus: Date.now()
		};
	},
	computed: {
		total() {
			return Math.ceil(this.$store.state.moduleProduct.sellTotal / this.customLimit);
		},
	},
	methods: {
		buyNow(sell) {
			sell.type = 1;
			sell.orderNow = 1;
			sell.address = null;
			this.customerData = sell;
			this.customerDialog = true;
		},
		gotoDetailSell(id) {
			this.$router.push('/chi-tiet-lenh-ban/'+id);
		},
		getRangePercent(sell){
			let price = parseInt(sell.price);
			let currPrice = parseInt(sell.curr_price);
			if (!price || !currPrice) {
				return 0;
			}
			return (price - currPrice) / currPrice;
		},
		filterByStatus(idxStatus) {
			this.productList.map((status, index) => {
				// status.active = (index == idxStatus) ? !status.active : 0;
				if (index == idxStatus) {
					status.active = !status.active;
				}
			});
			this.upStatus = Date.now();
			this.page = 1; // reset page
			this.getGetUsers();
		},
		printOrder(item) {
			console.log(item);
			// return;
            // var divContents = document.getElementById("test").innerHTML;
            var a = window.open(process.env.VUE_APP_GRAPHQL_DEFAULT_ENDPOINT+'/api/shipping-print/'+item.id+'?token='+this.userToken, '', 'height=800, width=800');
            // a.document.write('<html>');
            // a.document.write('<body > <h1>Div contents are <br>');
            // a.document.write(divContents);
            // a.document.write('</body></html>');
            // a.document.close();
			// a.focus();
            // a.print();

			// a.addEventListener('load', function() {
			// 	a.print();
			// 	a.close();
			// }, true);
        },
		onClickCancelOrder(id, event) {
			this.$vs.dialog({
				type: "confirm",
				color: "danger",
				title: this.$t("Actions.Confirm"),
				text: 'Thực hiện hủy lệnh số #'+id,
				// accept: () => this.deleteCustomer(customer._id),
				accept: () => this.cancelOrder(id),
				acceptText: this.$t("Actions.Agree"),
				cancelText: this.$t("Actions.Cancel")
			});
			if (event) {
				event.preventDefault()
			}
		},
		onClickEditOrder(data, event) {
			this.customerData = data;
			this.customerDialog = true;
			if (event) {
				event.preventDefault()
			}
		},
		onClickSellerRating(data, event) {
			let matchingId = 0;
			let cusName = '';
			if (data.type == 2) {
				matchingId = data.matching.id || '';
				cusName = data.matching.cus_name || '';
			} else {
				matchingId = data.matching_buy.id || '';
				cusName = data.matching_buy.supplier_name || '';
			}
			this.sellerRatingData = {
				type: data.type,
				id: data.id,
				matchId: matchingId,
				buyer_name: cusName,
				rating: data.rating,
				rating_note: data.rating_note
			};
			this.sellerRatingDialog = true;
			if (event) {
				event.preventDefault()
			}
		},
		onClickShippingOrder(data, event) {
			this.shippingData = {
				id: data.matching.id
			};
			this.shippingDialog = true;
			if (event) {
				event.preventDefault()
			}
		},
		onClickChooseSells(data, event) {
			this.sellsData = {
				id: data.id,
				status: data.status,
			};
			this.sellsDialog = true;
			if (event) {
				event.preventDefault()
			}
		},
		async cancelOrder(id) {
			this.$vs.loading();
			try {
				let payload = {
					id: id
				};
				await this.$store.dispatch("moduleProduct/cancelOrder", payload);
				this.getGetUsers();
				// this.$vs.loading.close();
			} catch (error) {
				this.$vs.loading.close();
			}
		},
		async getProducts() {
			const payload = {
			};
			try {
				this.$store.dispatch("moduleProduct/fetchProducts", payload).then(response => {
					let {data = []} = response;
					let productList = [
						// {
						// 	id: 0,
						// 	name: 'Tất cả',
						// 	active: 1,
						// 	color: 'primary',
						// },
					];
					if (data.length) {
						data.forEach (product => {
							productList.push(
								{
									id: product.id,
									name: product.name,
									active: 0,
									color: '#000000',
								}
							);
						})
					}
					this.productList = productList;
				})
			} catch (error) {
				console.log(error.message);
			}
		},
		async getGetUsers() {
			this.$vs.loading();
			let statuses = [];
			this.productList.map(status => {
				if (status.active) {
					statuses.push(status.id);
				}
			});
			// console.log(this.productList);
			this.filters.statuses = statuses;
			const payload = {
				// filters: this.filters,
				pids: statuses,
				// id: 0,
				page: this.page,
				limit: this.customLimit,
				// sort: this.sort,
				// type: 'sv'
			};
			try {
				await this.$store.dispatch("moduleProduct/getSellsList", payload);
				this.$vs.loading.close();
			} catch (error) {
				this.$vs.loading.close();
			}
		},
		handleSearch() {
			this.filters.fullname = this.searchText;
			this.getGetUsers();
		},
		openUserForm(user) {
			if (user) {
				this.editUser(user);
			} else {
				this.addNewUser();
			}
		},
		addNewUser() {
			this.userData = {};
			this.toggleUserDialog(true);
		},
		editUser(user) {
			// const _user = await this.$store.dispatch("moduleUser/fetchUser", user._id);
			this.userData = user;
			this.toggleUserDialog(true);
		},
	
		toggleShippingDialog(val = false) {
			this.shippingDialog = val;
		},
		toggleUserDialog(val = false) {
			this.userDialog = val;
		},
		toggleSellerRatingDialog(val = false) {
			this.sellerRatingDialog = val;
			if (!val) {
				this.customerData = {};
				this.getGetUsers();
			}
		},
		toggleSellsDialog(val = false) {
			this.sellsDialog = val;
			if (!val) {
				this.sellsData = {};
				this.getGetUsers();
			}
		},
		showDeleteUserConfirm(user) {
			this.$vs.dialog({
				type: "confirm",
				color: "danger",
				title: this.$t("Actions.Confirm"),
				text: this.$t("Notify.DeleteConfirm"),
				accept: () => this.deleteUser(user._id),
				acceptText: this.$t("Actions.Agree"),
				cancelText: this.$t("Actions.Cancel"),
			});
		},
		async deleteUser(userId) {
			this.$vs.loading();
			try {
				await this.$store.dispatch("moduleUser/removeRecord", userId);
				this.$vs.loading.close();
			} catch (error) {
				this.$vs.loading.close();
			}
		},
		handleOrderAction(type) {
			this.customerData.type = type;
			// this.customerData.product = this.detailUserDialogData;
			this.customerDialog = true;
		},
		handleClickItemRow(event, user) {
			const eventClasses = event.target && event.target.className;
			// show detail dialog if click target is not below classes
			if (event.target !== event.currentTarget && !eventClasses.split(" ").find((className) => ["cbs-context-menu", "cbs-color-picker", "item-relation--link"].includes(className))) {
				// const _user = await this.$store.dispatch("moduleUser/fetchUser", user._id);
				this.detailUserDialogData = user;
				this.toggleDetailSidebar(true);
			}
		},
		toggleCustomerDialog(val = false) {
			this.customerDialog = val;
			if (!val) {
				document.body.classList.remove("modal-open");
				this.customerData = {};
				this.getGetUsers();
			}
		},
		toggleDetailSidebar(val = false) {
			this.isDetailUserDialogActive = val;
		},
		toggleUserCustomerSidebar(val = false) {
			this.isDetailUserCustomerDialogActive = val;
		},
		handleSort(key, active) {
			const _key = key; // `_id.${key}`;
			this.sort = {};
			this.sort[_key] = active === "asc" ? 1 : -1;
			this.getGetUsers();
		},
		assignedZones(assignedZones) {
			// let _assignedZone = "";
			// Update property in user
			// assignedZones.map(assignedZone => {
			// 	_assignedZone = _assignedZone + (assignedZone.name + ", ");
			// });
			return assignedZones.reduce((zones, zone) => {
				zones += zone && zone.name ? `${zones ? ", " : ""}${zone.name}` : "";
				return zones;
			}, "");
			// _assignedZone = _assignedZone.slice(0, _assignedZone.lastIndexOf(","));
			// return _assignedZone;
		},
		showCustomerByUser(user) {
			this.detailUserCustomerDialogData = user;
			this.toggleUserCustomerSidebar(true);
		},
	},
	watch: {
		page() {
			this.getGetUsers();
		},
		searchText() {
			this.getGetUsers();
		},
	},
	created() {

		// Register Module UserManagement Module
		this.getGetUsers();
		this.getProducts();

		if (this.$store.state.AppActiveUser) {
			let { permissions = {}, token } = this.$store.state.AppActiveUser;
			let { supplier_can_select = false, user_can_buy = false, user_can_sell = false } = permissions;
			if (user_can_buy) {
				this.canBuy = true;
			}
			if (user_can_sell) {
				this.canSell = true;
			}
			if (supplier_can_select) {
				this.canSelectSupplier = true;
			}
			this.userToken = token;

			if (user_can_buy && !user_can_sell) {
				this.productList = [
					{
						id: 0,
						name: window.innerWidth > 600 ? 'Đang chờ' : 'Chờ',
						active: 0,
						color: 'primary',
					},
					{
						id: 1,
						name: window.innerWidth > 600 ? 'Khớp giá' : 'KG',
						active: 0,
						color: 'warning',
					},
					{
						id: 2,
						name: window.innerWidth > 600 ? 'Khớp lệnh' : 'KL',
						active: 0,
						color: 'success',
					},
				];
			} else if (!user_can_buy && user_can_sell) {
				this.productList = [
					{
						id: 0,
						name: window.innerWidth > 600 ? 'Đang chờ' : 'Chờ',
						active: 0,
						color: 'primary',
					},
					{
						id: 2,
						name: window.innerWidth > 600 ? 'Khớp lệnh' : 'KL',
						active: 0,
						color: 'success',
					},
					{
						id: 128,
						name: window.innerWidth > 600 ? 'Đã thanh toán' : 'TT',
						active: 0,
						color: 'dark',
					},
				];
			}
		}
		if (typeof localStorage === 'object' && localStorage) {
			let forceRelogin = localStorage.getItem('relogin');
			if (!forceRelogin) {
				localStorage.removeItem("accessToken");
				this.$acl.change("guest");
				localStorage.removeItem("userInfo");
				this.$router.push("/pages/login").catch(() => {});
				window.location = '/';
			}
		}
	},
};
</script>

<style lang="scss">
.item-filters {
	display: block;
}
.vx-navbar-wrapper {
	height: 80px !important;
}
.custom-wrap {
	width: 1410px;
	margin: auto;
}
.custom-dialog {
	z-index: 10001 !important;
}
.sell-trend-2 {
	position: absolute;
    width: 10px;
    height: 100%;
    top: -5px;
    left: 0px;
    z-index: 2;
	background: #FFFFFF;
}
.sell-trend {
	position: absolute;
	top: -10px;
	left: 0rem;
	background: #FFFFFF;
	padding: 5px 15px;
	box-shadow: 1px 0px 5px rgba(0, 0, 0, 0.5);
}
.sell-box {
	background: #FFFFFF;
	box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.5);
}
.sell-p-name {
	font-style: normal;
	font-weight: 700;
	font-size: 16px;
	line-height: 20px;
	/* identical to box height */


	color: #057FBB;
}
.sell-p-qty {
	font-style: normal;
	font-weight: 500;
	font-size: 12px;
	line-height: 15px;
	/* identical to box height */

	text-align: right;

	color: rgba(0, 0, 0, 0.6);
}
.sell-p-price {
	font-style: normal;
	font-weight: 500;
	font-size: 12px;
	line-height: 15px;
	/* identical to box height */


	color: rgba(0, 0, 0, 0.6);
}
.sell-p-ttl {
	font-style: normal;
	font-weight: 500;
	font-size: 10px;
	line-height: 12px;
	/* identical to box height */


	color: rgba(0, 0, 0, 0.6);
}
.sell-p-ttv {
	font-style: normal;
	font-weight: 700;
	font-size: 12px;
	line-height: 15px;
	/* identical to box height */


	color: #000000;

}
.sell-p-ttt {
	font-style: normal;
	font-weight: 500;
	font-size: 8px;
	line-height: 10px;
	/* identical to box height */


	color: rgba(0, 0, 0, 0.6);
}
.sell-img-box {
	width: 254px;
	height: 150px;
}
.sell-img-box img {
	object-fit: cover;
	width: 100%;
	height: 150px;
}
.btn-order-action {
	position: fixed !important;
	bottom: 20px;
	right: 10px;
	z-index: 9999;
}
#avatar-col {
	width: 10rem;
}

.vs-table--tbody-table {
	min-width: 300px !important;
}

#page-order-view {
	table {
		td:not(:first-child){
			vertical-align: top;
			// min-width: 140px;
			padding-bottom: 0.8rem;
			word-break: break-all;
		}

		// &:not(.permissions-table) {
		// 	td {
		// 		@media screen and (max-width: 370px) {
		// 			display: block;
		// 		}
		// 	}
		// }
	}
}

// #account-info-col-1 {
//   // flex-grow: 1;
//   width: 30rem !important;
//   @media screen and (min-width:1200px) {
//     & {
//       flex-grow: unset !important;
//     }
//   }
// }

@media screen and (min-width: 1201px) and (max-width: 1211px), only screen and (min-width: 636px) and (max-width: 991px) {
	#account-info-col-1 {
		width: calc(100% - 12rem) !important;
	}

	// #account-manage-buttons {
	//   width: 12rem !important;
	//   flex-direction: column;

	//   > button {
	//     margin-right: 0 !important;
	//     margin-bottom: 1rem;
	//   }
	// }
}

@media screen and (max-width: 600px) {
	.custom-wrap {
		width: 100%;
		margin: auto;
		justify-content: center !important;
	}

	.item-box {
		width: 90%;
	}
	.sell-img-box {
		width: 100%;
	}

	.item-filters {
		display: none !important;
	}
}

</style>
